module.exports = __webpack_public_path__ + "img/iq.iq942b6bf.svg";